export class AbortError extends Error {}

